import * as React from "react";
import PropTypes from 'prop-types';

const SvgImgNotAvailablePdp = props => {
  if (props.id !== "_svgimgnotavailablepdp") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path d="M14.6 0c.95 0 1.946.691 2.275 1.602l.465 1.287c.155.429.713.793 1.16.793h3.6c1.034 0 1.9.885 1.9 1.943v10.432C24 17.115 23.134 18 22.1 18H1.8C.766 18 0 17.115 0 16.057V5.625c0-1.058.766-1.943 1.8-1.943h3.8c.434 0 .897-.36 1.026-.784L7 1.656C7.285.716 8.237 0 9.2 0zM12 4a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm0 1c3.033 0 5.5 2.467 5.5 5.5S15.033 16 12 16s-5.5-2.467-5.5-5.5S8.967 5 12 5zm0 7.5a1 1 0 100 2 1 1 0 000-2zm1-6h-2v5h2v-5z" /></svg>;
};

SvgImgNotAvailablePdp.displayName = "_svgimgnotavailablepdp";
SvgImgNotAvailablePdp.propTypes = {
  id: PropTypes.string
};
SvgImgNotAvailablePdp.defaultProps = {
  id: ''
};
export default SvgImgNotAvailablePdp;